import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { ApiService } from '@core/services';
import { ApiResponse, QueryConfig } from '@shared/models';
import { Billing, Cfdi, EditModel, Invoice, Regime } from '@shared/models/billing.model';

@Injectable({
  providedIn: 'root',
})
export class BillingService {
  constructor(private apiService: ApiService) {}

  getInvoices(config: QueryConfig): Observable<ApiResponse<Invoice[]>> {
    return this.apiService.get<ApiResponse<Invoice[]>>('invoices', config);
  }

  createInvoice(payload: {
    billing_id: number;
    saldo_payment_id: number | null;
    suscription_payment_id: number | null;
  }): Observable<ApiResponse<Invoice>> {
    return this.apiService.post('invoices', payload);
  }

  getBillings(config: QueryConfig): Observable<ApiResponse<Billing[]>> {
    return this.apiService.get<ApiResponse<Billing[]>>('billings', config);
  }

  createBilling(billing: Billing): Observable<ApiResponse<Billing>> {
    return this.apiService.post<Billing>('billings', billing);
  }

  editBilling(billing: EditModel<Billing>): Observable<ApiResponse<Billing>> {
    return this.apiService.put<Billing>(`billings/${billing.id}`, billing);
  }

  deleteBilling(id: number): Observable<unknown> {
    return this.apiService.delete<Billing>(`billings/${id}`);
  }

  getRegimes(): Observable<Regime[]> {
    return this.apiService.get<ApiResponse<Regime[]>>('regimes').pipe(map((response) => response.data));
  }

  getCfdis(): Observable<Cfdi[]> {
    return this.apiService.get<ApiResponse<Cfdi[]>>('cfdis').pipe(map((response) => response.data));
  }
}
